import(/* webpackMode: "eager", webpackExports: ["PublisherProfilePage"] */ "/home/runner/work/compass-ui/compass-ui/apps/marketplace/src/app/[locale]/publisher/[id]/components/PublisherProfilePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MicrocopyProvider"] */ "/home/runner/work/compass-ui/compass-ui/apps/marketplace/src/contexts/MicrocopyContext.tsx");
